// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"5548bd43","665":"a6208011","838":"23fc0adb","979":"9ae534a8"}[chunkId] + ".chunk.css";
};